import Cookies from "js-cookie";

export default (uniqueBasketItemsLength) => {
    // Set unique basket items amount for future usage.
    Cookies.set("basket_unique_items_amount", uniqueBasketItemsLength, {
        expires: 30,
    });
};
